import Modal from './modal';

const HIDE_DELAY = 400;

class SideTabsFormModal {
	constructor(triggerEl) {
		this.triggerEl = triggerEl;
		this.index = triggerEl.dataset.formTrigger;
		this.blockEl = triggerEl.closest('.block-side-tabs') || document;

		this.contentEl = this.blockEl.querySelector(
			`.block-side-tabs__form-modal-content[data-form-index="${this.index}"]`
		);

		if (!this.contentEl) return;

		this.originalParent = this.contentEl.parentNode;
		this.originalNextSibling = this.contentEl.nextSibling;
		this.mountObserver = null;

		this.triggerEl.addEventListener('click', this.open);
	}

	/**
	 * Each Gravity Form is rendered once per page (see grav-blocks/side-tabs/block.php), so
	 * move it into this tab's slot and stamp this tab's title into the itinerary field.
	 */
	mountForm = () => {
		const slotEl = this.contentEl.querySelector('.block-side-tabs__form-slot');

		if (!slotEl) return;

		const formId = slotEl.dataset.gformId;
		const formEl = document.querySelector(
			`#gform_wrapper_${formId}, #gform_confirmation_wrapper_${formId}`
		);

		if (formEl && !slotEl.contains(formEl)) {
			slotEl.appendChild(formEl);
		}

		// The itinerary title field is tagged by bootstrap/plugins.php; its id differs per form
		// (an existing itinerary_title field keeps its own id, an added one is 9901).
		const itineraryInput = slotEl.querySelector(
			'.exeter-itinerary-title input, input[name="input_9901"]'
		);

		if (itineraryInput) {
			itineraryInput.value = slotEl.dataset.itineraryTitle || '';
		}
	};

	open = () => {
		this.mountForm();
		this.contentEl.classList.add('is-preparing-modal');
		this.contentEl.style.display = '';

		this.watchModalMount();

		Modal.show(this.contentEl, {
			callbacks: {
				onHide: this.close
			}
		});

		this.revealIfMounted();
	};

	watchModalMount = () => {
		if (this.mountObserver) {
			this.mountObserver.disconnect();
		}

		this.mountObserver = new MutationObserver(this.revealIfMounted);

		this.mountObserver.observe(document.body, {
			childList: true,
			subtree: true
		});
	};

	revealIfMounted = () => {
		const isInsideModal = this.contentEl.closest('.modal');

		if (!isInsideModal) return;

		if (this.mountObserver) {
			this.mountObserver.disconnect();
			this.mountObserver = null;
		}

		this.renderCaptcha();

		requestAnimationFrame(() => {
			this.contentEl.classList.remove('is-preparing-modal');
		});
	};

	/**
	 * Gravity Forms draws the reCAPTCHA on page load, while the form is still hidden in its tab.
	 * Moving the form into the modal reloads the reCAPTCHA iframe and breaks it ("The reCAPTCHA
	 * was invalid"), so draw a fresh one once the form is inside the open modal.
	 */
	renderCaptcha = () => {
		SideTabsFormModal.drawCaptcha(this.contentEl.querySelector('.ginput_recaptcha'));
	};

	static drawCaptcha(captchaEl) {
		if (!captchaEl || !window.grecaptcha || typeof window.grecaptcha.render !== 'function') return;

		// grecaptcha.render refuses an element it has already drawn into, so swap in an empty copy.
		const freshEl = captchaEl.cloneNode(false);
		captchaEl.replaceWith(freshEl);

		window.grecaptcha.render(freshEl, {
			sitekey: freshEl.dataset.sitekey,
			theme: freshEl.dataset.theme || 'light',
			tabindex: freshEl.dataset.tabindex || 0
		});
	}

	close = () => {
		if (this.mountObserver) {
			this.mountObserver.disconnect();
			this.mountObserver = null;
		}

		setTimeout(this.restoreNode, HIDE_DELAY);
	};

	restoreNode = () => {

		this.contentEl.style.display = 'none';
		this.contentEl.classList.remove('is-preparing-modal');

		if (this.originalNextSibling) {
			this.originalParent.insertBefore(
				this.contentEl,
				this.originalNextSibling
			);
		} else {
			this.originalParent.appendChild(this.contentEl);
		}
	};
}

// After a failed AJAX submit Gravity Forms swaps in new form markup. If its reCAPTCHA wasn't drawn
// (the box is missing inside the modal), draw it so the visitor can try again.
if (window.jQuery) {
	window.jQuery(document).on('gform_post_render', () => {
		setTimeout(() => {
			document.querySelectorAll('.modal .ginput_recaptcha').forEach((captchaEl) => {
				if (!captchaEl.querySelector('iframe')) {
					SideTabsFormModal.drawCaptcha(captchaEl);
				}
			});
		}, 500);
	});
}

export default SideTabsFormModal;